module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-how-production-eece3131be730fbc46c216a48548e99b.svg";